export const ROLE_USER = "ROLE_USER";
export const ROLE_ADMIN = "ROLE_ADMIN";

// A array containing all the roles that the user can have
// For example, it is used to determine if only existing roles are specified
export const ALL_ROLES = [
    ROLE_USER,
    ROLE_ADMIN
]
